import { render, staticRenderFns } from "./MatchWave.vue?vue&type=template&id=0f585e51&scoped=true"
import script from "./MatchWave.vue?vue&type=script&lang=js"
export * from "./MatchWave.vue?vue&type=script&lang=js"
import style0 from "./MatchWave.vue?vue&type=style&index=0&id=0f585e51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f585e51",
  null
  
)

export default component.exports